/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-collection.js
   - Collection/Search UX helpers (grid/list and collection carousels).
   - Native Collection filters/drawer are owned by es-native-filters.js.
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    function changeProdListGrid(){
        $('.prod_grid').off('click.eyeshellsProdGrid').on('click.eyeshellsProdGrid', function(){
          $('.product-grid-view').addClass('active');
          $('.product-list-view').removeClass('active');
          $(this).addClass('active');
          $('.prod_list').removeClass('active');
          $('.prod_per').removeClass('active');

        });
        $('.prod_list').off('click.eyeshellsProdList').on('click.eyeshellsProdList', function(){
          $('.product-grid-view').removeClass('active');
          $('.product-list-view').addClass('active');
          $(this).addClass('active');
          $('.prod_grid').removeClass('active');
          $('.prod_per').addClass('active');
        });
      }

    function js_draw_filter(){
        $(document)
          .off('click.eyeshellsDrawFilter', '.js-draw-filter-btn, .js-draw-filter-open')
          .on('click.eyeshellsDrawFilter', '.js-draw-filter-btn, .js-draw-filter-open', function(){
            var $trigger = $(this);
            var isOpen = $trigger.hasClass('js-draw-filter-open');
            $trigger.toggleClass('js-draw-filter-open', !isOpen);
            $trigger.toggleClass('js-draw-filter-btn', isOpen);
            $('.js-draw-filter').toggleClass('draw_filter', isOpen).toggleClass('col-lg-3', !isOpen);
            $('.js-draw-filter-2').toggleClass('col-lg-12', isOpen).toggleClass('col-lg-9', !isOpen);
          });
      }
    
    function checkclickcol(){
        $('.js-check-click-col').off('click.eyeshellsCheckCol').on('click.eyeshellsCheckCol', function(){
          $(this).toggleClass('active');
        });
      }
    
    function listcollection(){
        var $list = $('.js_list_col');
        if (!$list.length || !$list.slick || $list.hasClass('slick-initialized')) return;
        $list.slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
    
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
    
      }
    
    function jsDScollectionV1(){
        var $collection = $('.js_ds_collectionv1');
        if (!$collection.length || !$collection.slick || $collection.hasClass('slick-initialized')) return;
        $collection.slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                dots: false, 
                arrows: false
              }
            }
          ]
        });
    
      }
    
    function jscolbreacrumb(){
        var $breadcrumb = $('.js_col_breacrumb');
        if (!$breadcrumb.length || !$breadcrumb.slick || $breadcrumb.hasClass('slick-initialized')) return;
        $breadcrumb.slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 2,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
    
      }

    function runIf(sel, fn){ if (!sel) { try{fn();}catch(e){} return; } if ($(sel).length) { try{fn();}catch(e){} } }
    runIf(".prod_grid", changeProdListGrid);
    runIf(".js-draw-filter-btn", js_draw_filter);
    runIf(".js-check-click-col", checkclickcol);
    runIf(".js_list_col", listcollection);
    runIf(".js_ds_collectionv1", jsDScollectionV1);
    runIf(".js_col_breacrumb", jscolbreacrumb);
  });
})(window.jQuery);
